module.exports = __webpack_public_path__ + "img/item_icecream.789208e7.jpg";